import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CompactNumberPipe } from './compact-number.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [CompactNumberPipe],
  exports: [CompactNumberPipe],
})
export class CompactNumberPipeModule {}
